(function () {
  function init() {
    const productGrid = document.getElementById('product-grid');
    const paginationWrapper = document.querySelector('.pagination-wrapper');
    if (!productGrid || !paginationWrapper) return;

    // Create loading indicator
    const loader = document.createElement('div');
    loader.className = 'infinite-scroll-loader';
    loader.innerHTML = '<span>Loading more products...</span>';
    paginationWrapper.insertAdjacentElement('beforebegin', loader);

    let loading = false;

    function getNextPageUrl() {
      const nextLink = paginationWrapper.querySelector('.pagination__item--prev a, .pagination__item--prev');
      return nextLink ? nextLink.href : null;
    }

    function loadMore() {
      const nextPageUrl = getNextPageUrl();
      if (!nextPageUrl || loading) return;

      loading = true;
      loader.style.display = 'block';

      fetch(nextPageUrl)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newItems = doc.querySelectorAll('#product-grid .grid__item');
          const newPagination = doc.querySelector('.pagination-wrapper');

          newItems.forEach(item => productGrid.appendChild(item));

          if (newPagination) {
            paginationWrapper.innerHTML = newPagination.innerHTML;
          } else {
            paginationWrapper.remove();
          }

          loader.style.display = 'none';
          loading = false;
        })
        .catch(() => {
          loader.style.display = 'none';
          loading = false;
        });
    }

    window.addEventListener('scroll', () => {
      const threshold = 600;
      const distanceFromBottom = document.documentElement.scrollHeight - window.scrollY - window.innerHeight;
      if (distanceFromBottom < threshold) {
        loadMore();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
